import { useEffect } from "react";
import { publicPath } from "request";

const SetFavicon = () => {
  useEffect(() => {
    const favicon = document.querySelector("link[rel='icon']");
    if (favicon) {
      (favicon as HTMLLinkElement).href = `${publicPath}/favicon.ico`;
    } else {
      const newFavicon = document.createElement("link");
      newFavicon.rel = "icon";
      newFavicon.href = `${publicPath}/favicon.ico`;
      document.head.appendChild(newFavicon);
    }
  }, []);

  return null;
};

export default SetFavicon;
